<template>
  <div class="col-lg-10 col-lg-offset-1">
    <v-card flat class="futuristic-card">
      <div class="card-header">
        <h1 class="earth-color">UPDATE VAT</h1>
        <div class="title-decoration"></div>
      </div>
      <v-container>
        <v-form @submit.prevent="postVat()">
          <v-layout row wrap>
            <v-flex lg4 md6 sm12 xs12>
              <v-text-field
                label="Vat amount (%)"
                v-model="vat.rate"
                :rules="requiredRules"
                required
                type="number"
                class="futuristic-input"
              ></v-text-field>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-btn :depressed="true" block color="info" type="submit" class="futuristic-btn rounded-btn">Update VAT</v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      vat: {
        rate: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      }
    }
  },
  methods: {
    postVat: function () {
      this.$store.dispatch('post_vat', this.vat)
    }
  }
}
</script>

<style scoped>
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  overflow: hidden;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px 8px 0 0;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.futuristic-btn {
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.rounded-btn {
  border-radius: 24px !important;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .card-header {
    padding: 12px;
  }
  
  .earth-color {
    font-size: 1.35rem;
  }
}

@media (max-width: 600px) {
  .card-header {
    padding: 8px;
  }
  
  .earth-color {
    font-size: 1.2rem;
  }
}
</style>